
    import store from '../../../store'
    import {
        Vue,
        Component
    } from 'vue-property-decorator'

    @Component({
        name: 'zgxq'
    })
    export default class zgxq extends Vue {
        isPage=false
        select=''
        selectData=[]
        currentNo=  1
        pageSize=10
        pageTotal=0
        userzw=''
        props={
            checkStrictly: true,
            expandTrigger:'hover'
        }
        username=store.getters.user.username
        disabled=false
        zgxqtablelist=[]
        tableLoading=false
        mounted() {
            let that = this;
            that.loadData();
        }
        loadData() {
            let _that = this;
            _that.$request({
                method: 'post',
                url: '/bjba/zgxq/getSelectData',
                params:{
                    username:_that.username
                }
            }).then((response: any) => {
                console.log("selectdata:", response.data);
                let result = response.data;

                let zw=result.zw;
                this.userzw=zw;
                let bz=result.bz;
                if (zw=="02"){
                    // this.$router.push({
                    //     path:'/bjba/zg',
                    //     query:{bmid:bz,zw:zw}
                    // });
                    this.disabled = true;
                    _that.selectData=result.list;
                    this.select=this.selectData[0].bmid;
                    this.selectChanged();
                }else if (zw=="01"){
                    this.disabled = true;
                    _that.selectData=result.list;
                    this.select=this.selectData[0].bmid;
                    this.selectChanged();
                }else{
                    this.isPage=true;
                    _that.selectData=result.list;
                    this.getAllFirstBm();

                }
            }).catch((err: any) => {
                this.$message.error(err);
            })
        }
        selectChanged(){
            this.currentNo=1;

            let that=this;
            console.log("selectvalue:",this.select);
            if(!this.select) {
                this.isPage=true
                this.getAllFirstBm()
                return
            }
            this.tableLoading =true
            this.isPage=false
            this.$request({
                method: 'post',
                url: '/bjba/zgxq/selectChanged',
                params:{selectvalue:this.select,username: store.getters.user.username}
            }).then((response: any)=>{
                this.tableLoading =false
                console.log(response.data);
                // let json=JSON.stringify(response.data);
                // console.log(json);
                // console.log(typeof json);
                if(response.data.length==0){
                    // this.$router.push({
                    //     path:'/bjba/zg',
                    //     query:{bmid:this.select}
                    // });
                }
                that.zgxqtablelist=response.data;
            }).catch((err: any)=>{
                this.tableLoading =false
                console.log(err)
            });
        }
        getAllFirstBm(){
            this.tableLoading =true
            this.$request({
                method: 'get',
                url: '/bjba/zgxq/getALLfBMzG',
                params:{page:this.currentNo,pagesize: this.pageSize}
            }).then((response: any)=>{
                this.tableLoading =false
                console.log(response.data);

                this.zgxqtablelist=response.data.list;
                this.pageTotal = response.data.count;
            }).catch((err: any)=>{
                console.log(err)
            });
        }
        showzgxx(id,bmcj){
            console.log(id);
            this.$router.push({
                path:'/bjba/zg',
                query:{bmid:id,bmcj:bmcj}
            });
        }
        handleSizeChange(val: number) {
            this.pageSize = val;
            this.getAllFirstBm()
        }
        handleCurrentChange(val: number) {
            this.currentNo = val;
            this.getAllFirstBm()
        }
    }
